import { InformationDrawerProps } from "../../Unknown/InformationDrawer";
import useTranslations from "./useTranslations";

const useInformationDrawerActionButtons = (params: {
  isEditMode: boolean;
  isButtonsDisabled: boolean;
  handleEditModeChange: (value: boolean) => void;
  handleSubmit: () => void;
  resetForm: () => void;
  canMerge?: boolean;
  onMergeClick?: () => void;
}) => {
  const {
    isEditMode,
    isButtonsDisabled,
    handleEditModeChange,
    handleSubmit,
    resetForm,
    canMerge,
    onMergeClick,
  } = params;

  const { translations } = useTranslations();

  const { btnPatientEdit, btnPatientCancel, btnPatientSave, btnMerge } =
    translations;

  if (!isEditMode) {
    const viewModeButtons: InformationDrawerProps["actionButtons"] = [];

    if (canMerge && onMergeClick) {
      viewModeButtons.push({
        text: btnMerge,
        props: {
          disabled: isButtonsDisabled,
          variant: "contained",
          onClick: onMergeClick,
        },
      });
    }

    viewModeButtons.push({
      text: btnPatientEdit,
      props: {
        disabled: isButtonsDisabled,
        variant: "outlined",
        onClick: () => handleEditModeChange(true),
      },
    });

    return viewModeButtons;
  }

  const editModeButtons: InformationDrawerProps["actionButtons"] = [
    {
      text: btnPatientCancel,
      props: {
        disabled: isButtonsDisabled,
        variant: "text",
        onClick: () => {
          resetForm();
          handleEditModeChange(false);
        },
      },
    },
    {
      text: btnPatientSave,
      props: {
        disabled: isButtonsDisabled,
        variant: "contained",
        onClick: handleSubmit,
      },
    },
  ];

  return editModeButtons;
};

export default useInformationDrawerActionButtons;
